import React from 'react'
import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import classRankedLogoMob from '../../../../assets/classrankedLogo_Mob.svg'
import classRankedLogo from '../../../../assets/classRankedLogo.svg'
import { grey } from '../../../../colors'

export const LoginHeader = (): JSX.Element => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Stack spacing={8} alignItems='flex-start' sx={{ mb: 5 }}>
      <Box
        component='img'
        aria-label='ClassRanked logo'
        alt='ClassRanked logo'
        src={isMobile ? classRankedLogoMob : classRankedLogo}
        sx={{
          width: isMobile ? 64 : 240,
          height: 'auto',
          display: 'block'
        }}
      />
      <Stack spacing={1.5} alignItems='flex-start'>
        <Typography
          component='h1'
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.75rem' },
            fontWeight: 600,
            lineHeight: 1.25,
            color: grey[250],
            letterSpacing: '-0.01em'
          }}
        >
          Sign in
        </Typography>
        <Typography
          sx={{
            fontSize: '0.9375rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: grey[700]
          }}
        >
          Use your institution email to continue
        </Typography>
      </Stack>
    </Stack>
  )
}
